import React from "react";

import Product from "../../components/product/Product";

const ProductAdd = (props) => {
  return (
    <>
      <Product productItem={null} edit={false} id=""/>
    </>
  );
};

export default ProductAdd;
